"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExchangeAmount = exports.createExchange = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _payouts = require("@module/payouts");

var _request = _interopRequireDefault(require("@package/request"));

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var createExchange = function createExchange(formData) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result, item, count, notExit, _yield$request, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на конвертацию средств'
              });
              dispatch((0, _slice.createExchangeRequestAction)());
              _context.next = 5;
              return (0, _request["default"])({
                url: '/v2/payouts',
                method: 'post',
                data: {
                  externalId: formData['externalId'],
                  shopId: formData['shop']['id'],
                  amount: formData['sell-amount'],
                  currency: formData['sell-currency'],
                  description: formData['description'],
                  paymentMethod: 'Exchange',
                  destination: {
                    currency: formData['buy-currency']
                  },
                  details: [{
                    name: 'ExchangeAmount',
                    value: String(formData['buy-amount'])
                  }, {
                    name: 'ExchangeSign',
                    value: formData['sign']
                  }, {
                    name: 'ExchangeDate',
                    value: formData['date']
                  }]
                }
              });

            case 5:
              result = _context.sent;
              item = null;
              count = 0;
              notExit = true;

            case 9:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос созданной выплаты по id: ' + result['data']['externalId']
              });
              ++count;
              _context.next = 13;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 13:
              _context.next = 15;
              return (0, _request["default"])({
                url: "/payouts",
                method: 'get',
                params: {
                  externalId: result['data']['externalId']
                }
              });

            case 15:
              _yield$request = _context.sent;
              data = _yield$request.data;

              if (data.length > 0) {
                if (data[0]['externalId'] === formData['externalId']) {
                  if (data[0]['status']['code'] > 1 && data[0]['status']['code'] < 999) {
                    notExit = false;
                    item = data[0];
                  }
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context.next = 20;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 20:
              if (notExit) {
                _context.next = 9;
                break;
              }

            case 21:
              dispatch((0, _slice.createExchangeRequestSuccessAction)());
              dispatch((0, _payouts.createPayoutsRequestSuccessAction)(item));
              dispatch((0, _dialog.closeDialog)('create-exchange'));

              if (result['data']['token2FA']) {
                (0, _logger.push)({
                  owner: 'Navigate',
                  message: 'Необходимо ввести TwoFA для подтверждения конвертации по id: ' + result['data']['externalId']
                });
                dispatch((0, _dialog.openDialog)('confirm-twoFA', {
                  id: item['id']
                }));
              } else {
                dispatch((0, _dialog.openDialog)('create-exchange-success'));
                dispatch(notifications.push({
                  title: "\u041A\u043E\u043D\u0432\u0435\u0440\u0442\u0430\u0446\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
                  content: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u2116".concat(formData['externalId']),
                  mode: 'success',
                  autoClose: true
                }));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Конвертация средств успешно произведена'
              });
              _context.next = 35;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 32;
                break;
              }

              return _context.abrupt("return", void 0);

            case 32:
              dispatch((0, _slice.createExchangeRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при конвертации средств'
              });

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 28]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.createExchange = createExchange;

var getExchangeAmount = function getExchangeAmount(formData) {
  var isSell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var data, result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на расчет суммы конвертации'
              });
              dispatch((0, _slice.getExchangeAmountRequestAction)());
              data = {
                from: {
                  currency: formData['sell-currency']
                },
                to: {
                  currency: formData['buy-currency']
                }
              };

              if (isSell) {
                data['from']['amount'] = Number(formData['sell-amount']);
              } else {
                data['to']['amount'] = Number(formData['buy-amount']);
              }

              _context2.next = 7;
              return (0, _request["default"])({
                url: '/v2/exchange/calculation',
                method: 'post',
                data: data
              });

            case 7:
              result = _context2.sent;
              dispatch((0, _slice.getExchangeAmountRequestSuccessAction)(result));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Сумма для конвертации успешно расчитана'
              });
              return _context2.abrupt("return", result);

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 17:
              dispatch((0, _slice.getExchangeAmountRequestFailAction)(_context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при расчёте суммы конвертации'
              });

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getExchangeAmount = getExchangeAmount;